import { DateTime, Duration } from 'luxon';

export const DATE_HELPER_DEFAULT_TIME_ZONE = 'Europe/Paris'; // when client zones are used, maybe we should use Settings.defaultZoneName
export const DATE_HELPER_DATE_FORMAT_ISO = 'yyyy-MM-dd';
export const DATE_HELPER_TIME_FORMAT = 'HH:mm';
// eslint-disable-next-line @typescript-eslint/quotes
export const NON_ZULU_ISO_DATE_TIME_FORMAT = DATE_HELPER_DATE_FORMAT_ISO + "'T'" + DATE_HELPER_TIME_FORMAT; //T must be escapted with ' else it will be interpreted

export class DateHelper {
  public static setDateTimeTo1970(date: DateTime): DateTime {
    return DateTime.local(1970, 1, 1, date.hour, date.minute);
  }

  public static setDateTimeTo1970FromDuration(duration: Duration): DateTime {
    return DateTime.local(1970, 1, 1, 0, 0).plus(duration);
  }

  public static getDateTimeStart1970(): DateTime {
    return DateTime.fromISO('1970-01-01');
  }

  public static getDateFromIsoDateString(dateString: string): DateTime {
    return DateTime.fromISO(dateString);
  }

  public static toIsoDateStringFromJsDate(date: Date): string {
    if (!date) {
      return null;
    }
    return DateTime.fromJSDate(date).toFormat(DATE_HELPER_DATE_FORMAT_ISO);
  }

  public static toIsoDateString(date: DateTime | Date): string {
    if (!date) {
      return null;
    }
    if (date instanceof Date) {
      date = DateTime.fromJSDate(date);
    }
    return date.toFormat(DATE_HELPER_DATE_FORMAT_ISO);
  }

  public static getTimeOfDayDurationFromJsDate(date: Date): Duration {
    const dateTime = DateTime.fromJSDate(date);
    return dateTime.diff(dateTime.startOf('day'));
  };

  public static getDateTimeFromJsDateInTimeZone(date: Date, timeZone: string | luxon.Zone) {
    if (!date) {
      return null;
    }
    return DateTime.fromJSDate(date, {zone: timeZone});
  }

  // migrates to new timezone where time is shown same. e.g. 2022-06-23T10:00:00Z migrated to Europe/Paris will be 2022-06-23T10:00:00+02:00
  public static migrateTimeZone(dateTime: DateTime, timeZone: string | luxon.Zone) {
    const zonelessTime = dateTime.toUTC().toFormat(NON_ZULU_ISO_DATE_TIME_FORMAT);
    return DateTime.fromISO(zonelessTime, {zone: timeZone}).toString();
  }
}
